<template>
    <div class="print-risk-assessment__ra-section">
        <print-config-section v-for="(item, index) in configuration"
                              :config="item"
                              :answers="answers[index]"
                              :sectionIcon="sectionIcons[index]"
                              :questionIcons="questionsIcons[index]"
        />
    </div>
</template>

<script>
    import printConfigSection from "@components/pages/print/concrete/print-config-section"
    import assessment from "@mixins/helpers/_assessment";

    export default {
        name: "print-config-area",
        mixins: [ assessment ],
        components: {
            printConfigSection
        },
        props: {
            answers: {
                type: Array
            },
            configuration: {
                type: Array
            }
        },
        computed: {
            assessmentList() {
                return this.answers
            },
            questionsIcons() {
                let result = [];
                this.assessmentList.forEach((sectionAnswers) => {
                    let items = [];
                    sectionAnswers.children.forEach((questionAnswers) => {
                        items.push(this.assessmentHelper.questionIcon(questionAnswers))
                    });
                    result.push(items);
                });
                return result;
            },
            sectionIcons() {
                let result = [];
                this.questionsIcons.forEach((questionsIcons) => {
                    result.push(this.assessmentHelper.sectionIcon(questionsIcons))
                });
                return result;
            }
        }
    }
</script>


